import { EmojiClickData, SkinTones } from "emoji-picker-react";

export const defaultEmojis: EmojiClickData[] = [
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "👍",
    isCustom: false,
    names: ["thumbs up"],
    unified: "1f44d",
    unifiedWithoutSkinTone: "1f44d",
    getImageUrl: () => "",
    imageUrl: "",
  },
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "❤️",
    isCustom: false,
    names: ["heart"],
    unified: "2764-fe0f",
    unifiedWithoutSkinTone: "2764-fe0f",
    getImageUrl: () => "",
    imageUrl: "",
  },
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "✅",
    isCustom: false,
    names: ["white check mark", "white heavy check mark"],
    unified: "2705",
    unifiedWithoutSkinTone: "2705",
    getImageUrl: () => "",
    imageUrl: "",
  },
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "🎉",
    isCustom: false,
    names: ["party popper", "party popper"],
    unified: "1f389",
    unifiedWithoutSkinTone: "1f389",
    getImageUrl: () => "",
    imageUrl: "",
  },
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "🙏",
    isCustom: false,
    names: ["folded hands", "pray"],
    unified: "1f64f",
    unifiedWithoutSkinTone: "1f64f",
    getImageUrl: () => "",
    imageUrl: "",
  },
  {
    activeSkinTone: SkinTones.NEUTRAL,
    emoji: "🤔",
    isCustom: false,
    names: ["thinking face", "thinking"],
    unified: "1f914",
    unifiedWithoutSkinTone: "1f914",
    getImageUrl: () => "",
    imageUrl: "",
  },
];
